/**
 * @author Hideo Yamada
 * @description https://marvelapp.com/4gh2ba1/screen/47387792
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Icon from '@components/@core/Icon';

const Video = ({ className, type = 'presidents', title, url, onModal }) => {
    const dispatch = useDispatch();
    const handleModal = (e) => {
        dispatch(AppActions.modalRequest(e));
    };

    return (
        <div className={cx('video', className)}>
            <div className="video-type-view">
                <Image className="video-logo" src={`/images/landing/events_${type}_logo.png`} />
                {!!title && <p className="dsl-w18 bold mb-0">{title}</p>}
            </div>
            <div className="video-split" />
            <div className="video-play-view" style={{ backgroundImage: `url(/images/landing/events_${type}_video.png)` }}>
                <div className="video-overlay" />
                <Button
                    className="play"
                    onClick={() =>
                        onModal({
                            type: 'Landing modal',
                            data: {
                                before: {
                                    url,
                                    height: window.innerWidth <= 475 ? 200 : 360,
                                    width: window.innerWidth <= 475 ? 360 : 640,
                                },
                            },
                        })
                    }
                >
                    <Icon name="fas fa-play" size={30} color="#fff" />
                </Button>
            </div>
        </div>
    );
};

Video.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(['presidents', 'dses', 'leadership', 'webinar']),
    url: PropTypes.string,
};

export default Video;
